import { getAuthApiUrl, getStoredSessionToken } from '@/app/services/session.service';

async function parseJson(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function getPlatformBranding() {
  const response = await fetch(getAuthApiUrl('/api/platform/branding'));
  if (!response.ok) {
    throw new Error('PLATFORM_BRANDING_UNAVAILABLE');
  }
  return parseJson(response);
}

export async function getTenantBranding() {
  const token = getStoredSessionToken();
  const response = await fetch(getAuthApiUrl('/api/tenant/branding'), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    throw new Error('TENANT_BRANDING_UNAVAILABLE');
  }
  return parseJson(response);
}
